var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-tooltip", { attrs: { effect: "light", placement: "top" } }, [
        _c(
          "div",
          {
            staticClass: "tip_con",
            attrs: { slot: "content" },
            slot: "content",
          },
          [_vm._v(_vm._s(_vm.title))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title ellipsis" }, [
          _vm._v(" " + _vm._s(_vm.title)),
        ]),
      ]),
      _vm._v(" "),
      _c("span", {
        staticClass: "account ellipsis2",
        domProps: { innerHTML: _vm._s(_vm.desc) },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }